import { render, staticRenderFns } from "./EditProduct.vue?vue&type=template&id=b268bef8&"
import script from "./EditProduct.vue?vue&type=script&lang=js&"
export * from "./EditProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports